import React, { Component } from 'react'
import { matchPath, withRouter } from 'react-router-dom';
import * as Constants from '../../common/Global/constants';
import { getThemeSettingsVariables } from '../../common/Global/commonFunctions';
import { TopTabsLayout } from '../../common/Global/globalStyles.style';

let isProfile ='';
let isEmailNotification ='';
let isUsersetting = '';
let themeColor = ``;
let themeSettings = getThemeSettingsVariables();

class ProfileTopMenu extends Component {
    constructor(props) {
        super(props);
        this.state = {
            showLoader: false,
        }
        themeSettings = getThemeSettingsVariables();
        isProfile = this.checkActivePath("/profile");
        isEmailNotification = this.checkActivePath("/emailnotification");
        isUsersetting = this.checkActivePath("/usersetting");
    }

    checkActivePath = (path) =>{
        themeSettings = getThemeSettingsVariables();
        themeColor = `rgba(${themeSettings.themeColor.r},${themeSettings.themeColor.g},${themeSettings.themeColor.b},${themeSettings.themeColor.a})`;
       return matchPath(this.props.history.location.pathname, { path });
    }

    render() {
        return (
            <TopTabsLayout themeSettings={this.props.themeSettings}>
                <div className="question-tabs" style={{ marginRight: 0 }}>
                    <ul>
                        <li
                            className={
                                matchPath(this.props.history.location.pathname, { path: "/profile" })
                                    ? "questiontab-active"
                                    : ""
                            }
                        >
                            <a href={Constants.URL_PROFILE}
                                style={{color: !isProfile ? themeColor : '', fontWeight: !isProfile ? "bold" : "100px"}}>My Profile</a>
                        </li>
                        {/* <li
                            className={
                                matchPath(this.props.history.location.pathname, { path:"/emailnotification"})
                                    ? "questiontab-active"
                                    : ""
                            }
                        >
                            <a href={Constants.URL_EMAIL_NOTIFICATION}
                                style={{color: !isEmailNotification ? themeColor : '', fontWeight: !isEmailNotification ? "bold" : "100px"}}>Email Notification</a>
                        </li> */}
                        <li
                            className={
                                matchPath(this.props.history.location.pathname, { path:"/usersetting"})
                                    ? "questiontab-active"
                                    : ""
                            }
                        >
                            <a href={Constants.URL_USER_SETTING}
                                style={{color: !isUsersetting ? themeColor : '', fontWeight: !isUsersetting ? "bold" : "100px"}}>User Setting</a>
                        </li>
                    </ul>
                </div>
            </TopTabsLayout>
        )
    }
}

export default withRouter(ProfileTopMenu);